import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../axiosInstance";

const BASE_URL = `${process.env.REACT_APP_LISTOGRAPHY_API_PREFIX}`;

export const fetchTVShowLists = createAsyncThunk(
  "tvshows/fetchLists",
  async () => {
    const response = await axios.get(`${BASE_URL}/api/lists/tvshow`);
    return response.data;
  }
);

export const fetchTVShowList = createAsyncThunk(
  "tvshows/fetchList",
  async (sid) => {
    console.log("calling tv show list with sid ", sid);
    const response = await axios.get(`${BASE_URL}/api/lists/tvshow/${sid}`);
    return response.data;
  }
);

const tvShowListSlice = createSlice({
  name: "tvShowLists",
  initialState: {
    tvShowLists: [],
    tvShowList: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    clearTVShowList: (state) => {
      state.tvShowList = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetch tv show lists
      .addCase(fetchTVShowLists.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTVShowLists.fulfilled, (state, action) => {
        state.tvShowLists = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchTVShowLists.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      // fetch tv show list
      .addCase(fetchTVShowList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchTVShowList.fulfilled, (state, action) => {
        state.tvShowList = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchTVShowList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearTVShowList } = tvShowListSlice.actions;

export default tvShowListSlice.reducer;
